<template>
    
    <div class="list" :class="{ 'filtered': filtering && filtering.isFiltered, 'sortable': hasSortableItems }" ref="list">

        <div class="list__actions" v-if="hasActionsSlot">
            <slot name="actions"></slot>
        </div>

        <div class="list__filters" v-if="hasFiltersSlot">

            <slot name="filters"></slot>

        </div>
                
        <div class="list__results">
            <span class="list__results__count">{{ resultLabel }}</span>
            <template v-if="filtering && filtering.isFiltered">
                <span class="list__results__filter-count">{{ filtering.filterCount }} {{ filtering.filterCount > 1 ? 'filtres' : 'filtre' }}</span>
                <a class="list__results__filter-reset" href="#" @click.prevent="filtering.reset()">Effacer tous  les filtres</a>
            </template>
        </div>

        <div class="list__checkbox-actions" v-if="hasCheckboxActionsSlot">
            <slot name="checkboxActions"></slot>
        </div>

        <div class="list__heading" v-if="hasHeadingSlot">
            <div class="list__heading__control" @click="toggleSortingControl">
                <span class="list-sorting" v-if="isSorted">
                    {{ this.sortBy }}
                    <i class="sort-by-asc" v-if="orderBy === 'ASC'" />
                    <i class="sort-by-desc" v-if="orderBy === 'DESC'" />
                </span>
                <span class="list-sorting" v-if="!isSorted && hasSortableItems">
                    Trier par
                    <i class="sort-by-desc" />
                </span>
            </div>
            <div class="list__heading__items"
                :class="{ 'active': sortingDropdown }" >
                <slot name="heading"></slot>
            </div>
        </div>

        <div class="list__data">
            <slot></slot>
            <Loader v-if="filtering && filtering.isFiltering" />
        </div>

        <div class="list__footer" v-if="hasFooterSlot">
            <slot name="footer"></slot>
        </div>

        <div class="list__checkbox-actions" v-if="hasCheckboxActionsSlot">
            <slot name="checkboxActions"></slot>
        </div>

        <div class="list__filterbar" v-if="filtering && filtering.isFiltered">
            <div class="filterbar">
                <div class="filterbar__results">
                    <span v-if="!filtering.isFiltering">{{ resultLabel }}</span>
                </div>
                <button
                    class="woocommerce-button button alt"
                    type="button"
                    @click="filtering.reset()">
                    Effacer les filtres
                </button>
            </div>
        </div>

    </div>

</template>

<script>
import CellVue from './Cell.vue'
import ListItemVue from './ListItem.vue'
import SorterVue, { SORT_EVENT, SortBus } from './Sorter.vue'
import FilterVue from './filters/Filter.vue'
import TogglerAllVue from './TogglerAll.vue'
import Loader from '@/components/loader/Loader.vue'

export const ITEMS_PER_PAGE = 50
export const Cell = CellVue
export const ListFilter = FilterVue
export const ListItem = ListItemVue
export const Sorter = SorterVue
export const TogglerAll = TogglerAllVue

export default {

    data: function() {
        return {
            hasActionsSlot: false,
            hasCheckboxActionsSlot: false,
            hasHeadingSlot: false,
            hasFiltersSlot: false,
            hasFooterSlot: false,
            hasSortableItems: false,
            orderBy: null,
            sortBy: null,
            sortingDropdown: false
        }
    },

    props: {

        filtering: {
            type: Object,
            required: false,
            default: null
        },

        itemNameSingular: {
            type: String,
            default: null
        },

        itemNamePlural: {
            type: String,
            default: null
        }
    },

    computed: {

        isSorted: function() {
            return ( this.sortBy !== undefined
                && this.sortBy !== null
                && this.sortBy !== '' )
        },

        resultLabel: function() {

            if (
                this.filtering === null ||
                typeof this.filtering.count !== 'number'
            ) {
                return ''
            }

            let count = this.filtering.count
            let entityName = ( count > 1 ) ?
                ( this.itemNamePlural !== null ) ? this.itemNamePlural : 'résultats'
                : ( this.itemNameSingular !== null ) ? this.itemNameSingular : 'résultat' ;

            return ( count + ' ' + entityName )
        },
    },

    methods: {
        
        closeDropdown() {
            this.sortingDropdown = false
        },

        toggleSortingControl() {
            this.sortingDropdown = !this.sortingDropdown
        },
    },

    mounted() {

        this.hasActionsSlot = !!this.$slots['actions']
        this.hasCheckboxActionsSlot = !!this.$slots['checkboxActions']
        this.hasHeadingSlot = !!this.$slots['heading']
        this.hasFiltersSlot = !!this.$slots['filters']
        this.hasFooterSlot = !!this.$slots['footer']

        SortBus.$on(SORT_EVENT, sort => {
            this.orderBy = sort.orderBy
            this.sortBy = sort.label
            this.closeDropdown()
        })
        
        setTimeout(() => {
            this.hasSortableItems = ( this.$el.querySelectorAll('.criteria').length > 0 )
        }, 100)
    },

    components: {
        Loader
    }
}

</script>

<style>

.list {
    position: relative;
}

/* @deprecated */
.list tr.clickable:hover {
    color: rgb(0, 0, 0);
    cursor: pointer;
    background-color: rgba(13, 197, 193, 0.7);
} 

.list .list__actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 1rem;
}

.list .list__actions .button + .button {
    margin-left: 1rem;
}

.list .list__checkbox-actions {
    margin: 1rem 0;
}

.list .list__checkbox-actions .button + .button {
    margin-left: 1rem;
}

.list .list__data {
    position: relative;
}

.list .list__content,
.list .list__content li,
.list .list__content .list__content__item {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.list .list__content .list__content__item {
    margin: 1rem 0;
}

.list .list__content .list__content__sublist {
    line-height: 2rem;
    padding: 0.5rem 1rem;
    border-bottom: 1px solid rgba(0,0,0,0.11);
}

.list .list__content:not(:first-child) .list__content__sublist {
    padding-top: 2rem;
}

.list .list__filters {
    display: flex;
    flex-direction: column;
    gap: 1rem 1.5rem;
    margin-bottom: 1rem;
}

.list .list__filterbar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
}

.list .list__results {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 1rem 0;
    gap: 0.5rem;
    text-wrap: nowrap;
}

.list .list__results > * {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2.3rem;
}

.list .list__results .list__results__count {
    font-size: 120%;
    margin-right: 0.5rem;
}

.list .list__results .list__results__filter-count,
.list .list__results .list__results__filter-reset {
    font-weight: bold;
    color: rgb(3, 115, 107);
    background-color: rgba(30, 142, 134, 0.55);
    border: 2px solid transparent;
    border-radius: 0.25rem;
    padding: 0 0.8em;
}

.list .list__results .list__results__filter-reset,
.list .list__results .list__results__filter-reset:active,
.list .list__results .list__results__filter-reset:hover,
.list .list__results .list__results__filter-reset:focus {
    background-color: transparent;
    color: rgba(30, 142, 134);
    border: 2px solid rgba(30, 142, 134, 0.55);
    text-decoration: none;
}

.list .list__heading {
    position: relative;
    width: 100%;
    border-bottom: 2px solid rgba(0,0,0,0.11);
}

.list .list__heading .list__heading__control {
    line-height: 3rem;
}

.list .list__heading .list__heading__items {    
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;

    margin-top: -2px;
    padding: 2rem;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2rem 6rem rgba(0, 0, 0, 0.46);
}

.list .list__heading .list__heading__items:not(.active) {
    display: none;
}

.list .list__heading .cell {
    font-weight: 700;
    line-height: 2rem;
}

.list .list__heading .cell:not(.criteria) {
    display: none;
}

.list .list__heading .cell.cell--actions {
    visibility: hidden;
}

.list .list__heading .cell.cell--cb {
    padding: 0 0.5rem;
    max-width: 3rem;
    width: 3rem;
}

.list .list__footer .list__footer__row {
    display: flex;
    flex-direction: row;
}

.list .list__footer .list__footer__row .cell {
    font-weight: bold;
}

.list .list__footer .list__footer__row .cell:nth-child(1) {
    flex: 1;
}

.list .list__next {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 9rem;
}

.list .list__next > .button {
    width: 100%;
}

.list-sorting {
    display: inline-block;
    cursor: pointer;
}

.filterbar {    
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 5rem;
    padding: 0 2rem;
    background-color: rgb(242, 244, 245);
}

.filterbar__results {
    flex: 1;
    font-size: 150%;
    margin-right: 2rem;
}

.list.filtered {
    margin-bottom: 7rem;
}

@media screen and (min-width: 800px) {

    .list .list__heading .list__heading__control {
        display: none;
    }

    .list .list__heading .list__heading__items,
    .list .list__heading .list__heading__items:not(.active) {
        display: flex;
        flex-direction: row;
        width: 100%;

        position: initial;
        margin-top: 0;
        padding: 0;
        background-color: transparent;
        box-shadow: none;
    }

    .list .list__content .list__content__item {
        margin: 0;
    }
    
    .list .list__content .list__content__item:nth-child(even) {
        background-color: #f7f7f7;
    }
    
    .list .list__filters {
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 2rem 0;
    }

    .list .list__filterbar {
        left: 17rem;
    }

    .list .list__results {
        margin: 2rem 0;
        padding: 0 0.5rem;
    }

    .list .list__next > .button {
        width: auto;
    }    

    .list .list__heading .cell,
    .list .list__content .cell {
        flex: 1;
        min-width: 135px;
        padding: 0 0.5rem;
        white-space: nowrap;
        width: auto;
    }

    .list .list__heading .cell.cell--cb,
    .list .list__content .cell.cell--cb {
        padding: 0 0.5rem !important;
        max-width: 3rem !important;
        width: 3rem !important;
        min-width: auto !important;
    }

    .list .list__heading .cell.cell--main,
    .list .list__content .cell.cell--main {        
        flex: 1.5;
        min-width: 175px;
    }

    .list .list__heading .cell {
        line-height: 3rem;
    }

    .list .list__heading .cell:not(.criteria) {
        display: inherit;
    }
}

/**
 * Style Product
 */

@media screen and (min-width: 800px) {

    .list.list--products .cell {
        flex: 0.5;
        min-width: 115px;
    }

    .list.list--products .cell.cell--main {
        flex: 2.5;
        min-width: 175px;
    }
}

/**
 * Style Table
 */
.list.list--table .list__heading {
    display: none;
}

.list.list--table .list__content .list__content__item {
    border: 1px solid rgba(0,0,0,0.11);
    margin: 0;
    padding: 1rem 1.5rem 1rem 1.25rem;
}

.list.list--table .list__content .list__content__item:not(:last-child) {
    border-bottom: 0 none;
}

.list.list--table .list__footer .list__footer__row {
    border: 1px solid rgba(0,0,0,0.11);
    border-top: 0 none;
}

.list.list--table .list__footer .list__footer__row .cell {
    padding: 0.8rem 1.5rem 0.8rem 1.25rem;
    background-color: #f8f8f8;
}

.list.list--table .list__footer .list__footer__row .cell:nth-child(1) {
    background-color: #f8f8f8;
}

@media screen and (min-width: 800px) {

    .list.list--table .list__heading {
        display: block;
        margin-bottom: 0;
        background-color: #f8f8f8;
        border: 1px solid rgba(0,0,0,0.11);
        border-bottom: 0 none;
    }

    .list.list--table .list__content .list__content__item {
    padding: 0;
    }

    .list.list--table .cell {
        flex: 0.5;
        min-width: 85px;
    }   

    .list.list--table .list__content .list__content__item:nth-child(even) {
        background-color: transparent;
    }

    .list.list--table .list__footer .list__footer__row .cell:nth-child(2) {
        min-width: 85px;
        background-color: transparent;
    }

    .list.list--table .cell.cell--main {
        flex: 2.5;
        min-width: 175px;
    }
}

</style>